import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCsrfTokenFn,
// 获取csrf token
getJobLeaveFn as _getJobLeaveFn,
// 获取职等列表
saveGradeFn,
// 保存职等
saveLeaveFn,
// 保存职级
getLeaveFn as _getLeaveFn,
// 获取职级
delJobLeaveFn,
// 删除职等
delRankFn // 删除职级
} from 'api/org/position';
var dataForm = {
  grade: '',
  leave: ''
};
export default {
  props: {
    visible: {
      default: false
    }
  },
  data: function data() {
    return {
      disabled: false,
      dataForm: dataForm,
      csrfToken: '',
      job: {
        leave: [],
        grade: []
      }
    };
  },
  watch: {
    visible: function visible(v) {
      if (v) this.init();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCsrfTokenFn();
            case 2:
              res = _context.sent;
              _this.csrfToken = res.data.csrf_token;
              _this.getJobLeaveFn();
              _this.getLeaveFn();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取职等
    getJobLeaveFn: function getJobLeaveFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getJobLeaveFn();
            case 2:
              res = _context2.sent;
              _this2.job.grade = res.data.list;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取职级
    getLeaveFn: function getLeaveFn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getLeaveFn();
            case 2:
              res = _context3.sent;
              _this3.job.leave = res.data.list;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 保存职等
    handlerSaveGrade: function handlerSaveGrade() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return saveGradeFn({
                name: _this4.dataForm.grade.trim(),
                csrf_token: _this4.csrfToken
              });
            case 2:
              res = _context4.sent;
              _this4.dataForm.grade = '';
              _this4.getJobLeaveFn();
              _this4.csrfToken = res.data.csrf_token;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 保存职级
    handlerSaveLeave: function handlerSaveLeave() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return saveLeaveFn({
                name: _this5.dataForm.leave.trim(),
                csrf_token: _this5.csrfToken
              });
            case 2:
              res = _context5.sent;
              _this5.dataForm.leave = '';
              _this5.getLeaveFn();
              _this5.csrfToken = res.data.csrf_token;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 删除职等
    handlerDelLeave: function handlerDelLeave(id, index) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return delJobLeaveFn({
                grade_id: id
              });
            case 2:
              _this6.job.grade.splice(index, 1);
              _this6.getJobLeaveFn();
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 删除职级
    handlerDelRank: function handlerDelRank(id, index) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return delRankFn({
                rank_id: id
              });
            case 2:
              _this7.job.grade.splice(index, 1);
              _this7.getLeaveFn();
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeSelf: function closeSelf() {
      this.$emit('update:visible', false);
    }
  }
};